import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { OrderPipe } from '../../../../../components/agent-performance/components/scorecard-section/pipes/order.pipe';
import { StatusLabelPipe } from '../../../../../components/agent-performance/pipes/status-label.pipe';
import { ScorecardPercentagePipe } from '../../../../pipes/scorecard-percentage.pipe';
import { ScorePointsPipe } from '../../../../pipes/score-points.pipe';
import { QUERY_PARAMS } from '../../../../../core/configurations/router';
import { ActivatedRoute } from '@angular/router';
import { IStatement } from '../../../../models/scorecard-section.model';
import { IPdfScorecard } from '../../../../../core/services/pdf-export.service';

@Component({
  selector: 'cv-pdf-scorecard',
  standalone: true,
  imports: [DatePipe, OrderPipe, StatusLabelPipe, ScorecardPercentagePipe, ScorePointsPipe, NgClass],
  templateUrl: './pdf-scorecard.component.html',
  styleUrl: '../../pdf-styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfScorecardComponent {
  @Input({ required: true }) scorecard!: IPdfScorecard;
  @Input() isLastScorecard: boolean = false;

  constructor(private readonly activatedRoute: ActivatedRoute) {}

  get statements(): IStatement[] {
    return this.scorecard?.sections.reduce(
      (statements, section) => statements.concat(section.statements),
      [] as IStatement[],
    );
  }

  get showHiddenStatements(): boolean {
    return (
      (this.activatedRoute.snapshot.queryParams[QUERY_PARAMS.hiddenQuestions] as string | undefined)?.toLowerCase() ===
      'display'
    );
  }
}
